import React from 'react'

import startGame from '../../actions/startGame'
import joinGame from '../../actions/joinGame'
import logIn from '../../actions/logIn'
import {
  FixedAction,
  Button,
} from '../styles'

const confirmText = 'Has everyone joined? Once the game starts, you can\'t add new players'

const WaitingAction = ({players, player, auth, game}) => {
  if (!auth) {
    return <FixedAction>
        <Button primary onClick={logIn}>Sign in with Google to join</Button>
      </FixedAction>
  }

  if (!player) {
    return <FixedAction>
        <Button primary onClick={() => joinGame(game.id)}>Join this game</Button>
      </FixedAction>
  }

  if (!player.admin) {
    return "Waiting for the game to start..."
  }

  if (players.length < 2) {
    return "Waiting for more players..."
  }

  return <FixedAction>
      <Button primary onClick={() => {
        if (window.confirm(confirmText)) {
          startGame({players, game})
        }
      }}>
        Start the game!
      </Button>
    </FixedAction>
}

export default WaitingAction



// WEBPACK FOOTER //
// ./src/views/game/1_WaitingAction.jsx